import numeral from 'numeral';

export class PercentageValueConverter {
  toView(value) {
    return numeral(value).format('0%');
  }
}
